
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LeaderboardRecord } from "../types";

export const useLeaderboardData = () => {
  const [leaderboardData, setLeaderboardData] = useState<LeaderboardRecord[]>([]);
  const [filteredData, setFilteredData] = useState<LeaderboardRecord[]>([]);

  const fetchLeaderboardData = async () => {
    try {
      const { data, error } = await supabase
        .from('leaderboard')
        .select('*')
        .order('internal_id', { ascending: true });
      
      if (error) {
        console.error('Error fetching leaderboard data:', error);
        return;
      }
      
      if (data) {
        setLeaderboardData(data);
        setFilteredData(data);
      }
    } catch (error) {
      console.error('Error fetching leaderboard data:', error);
    }
  };

  useEffect(() => {
    fetchLeaderboardData();
  }, []);

  return {
    leaderboardData,
    filteredData,
    setFilteredData
  };
};
